import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import ConfirmDoctor from "../ConfirmDoctor/ConfirmDoctor";
import DoctorAgreement from "../DoctorAgreement/DoctorAgreement";
import MainDoctor from "../MainDoctor/MainDoctor";
import { getUserInfo, updateUserInfo } from "../../../db/users";

function InitDoctorFlow() {
  const authCtx = useContext(AuthContext);
  const [isFetching, setIsFetching] = useState(true);
  const [fetchedDoctor, setFetchedDoctor] = useState({});
  const token = authCtx.token;
  const userId = authCtx.userId;

  useEffect(() => {
    async function getDoctor() {
      setIsFetching(true);
      const response = await getUserInfo(userId, token);
      setFetchedDoctor(response.data);
      authCtx.storeCurrentDoctor(createContextDoctor(response.data));
      setIsFetching(false);
    }
    getDoctor();
    // eslint-disable-next-line
  }, [userId, token]);

  async function agreedChosenHandler(isAccepted) {
    if (isAccepted) {
      await updateUserInfo(userId, { doctorAgreed: true }, token);
      let clonedDoctor = Object.assign([], fetchedDoctor);
      clonedDoctor.doctorAgreed = true;
      setFetchedDoctor(clonedDoctor);
    } else {
      alert(
        "Debes aceptar el aviso de privacidad para utilizar está aplicación."
      );
    }
  }

  function createContextDoctor(doctor) {
    return {
      name: doctor.name,
      lastName: doctor.lastName,
      surName: doctor.surName,
      speciality: doctor.speciality,
      cardId: doctor.cardId,
      email: doctor.email,
      cellPhone: doctor.cellPhone,
      key: userId,
    };
  }

  function confirmDoctorHandler(name, lastName, surName, cardId, speciality) {
    let clonedDoctor = Object.assign([], fetchedDoctor);
    clonedDoctor.doctorConfirmedData = true;
    clonedDoctor.name = name;
    clonedDoctor.lastName = lastName;
    clonedDoctor.surName = surName;
    clonedDoctor.speciality = speciality;
    clonedDoctor.cardId = cardId;
    authCtx.storeCurrentDoctor(createContextDoctor(clonedDoctor));
    setFetchedDoctor(clonedDoctor);
  }

  if (isFetching) {
    return <p>Cargando...</p>;
  }

  if (fetchedDoctor && userId && !fetchedDoctor.doctorConfirmedData) {
    return (
      <ConfirmDoctor
        doctor={fetchedDoctor}
        onConfirmDoctorData={confirmDoctorHandler}
      />
    );
  } else if (fetchedDoctor && userId && !fetchedDoctor.doctorAgreed) {
    const data = {
      fullName: `${fetchedDoctor.name} ${fetchedDoctor.lastName} ${fetchedDoctor.surName}`,
      speciality: fetchedDoctor.speciality,
      cardId: fetchedDoctor.cardId,
    };
    return <DoctorAgreement onOptionChosen={agreedChosenHandler} data={data} />;
  } else if (fetchedDoctor && userId) {
    return <MainDoctor />;
  }
}

export default InitDoctorFlow;
